import { PageSection } from '../../../PageSection/PageSection';
import SavedSearchesButton from '../../../SavedSearches/SavedSearchesButton';
import SaveNewSearchButton from '../../../SavedSearches/SaveNewSearchButton';
import { InlineSearchBar } from '../../../SearchBar/InlineSearchBar';
import { useSearchResultsPageContext } from '../../contexts/SearchResultsPageContext';
import { useVendorSearchNavigation } from '../../contexts/VendorSearchNavigationContext';
import { MobileSearchDropdownsPlaceholder } from '../SearchControls/MobileSearchDropdownsPlaceholder';
import { useSRPSearchBarContext } from '../SearchControls/SRPSearchBarContext';
import { TotalVendorsDescription } from '../TotalVendorsDescription/TotalVendorsDescription';

import styles from './pageHeading.module.less';

/** An alternative (A/B tested header for the page) */
export const PageHeading = ({ shouldCloseDropdowns }: { shouldCloseDropdowns: boolean }) => {
  const {
    vendorSearch,
    selectedFacetOptions,
    searchResults: { totalHits },
  } = useSearchResultsPageContext();
  const { selectedTaxonomy, availabilityDates } = vendorSearch;

  const { navigateToSrp } = useVendorSearchNavigation();

  const { selectedLocation, updateSelectedLocation, nextTaxonomySearch, setNextTaxonomySearch } =
    useSRPSearchBarContext();

  return (
    <PageSection noPadding className={styles.pageHeading}>
      <div className={styles.pageHeadingContent}>
        <TotalVendorsDescription
          totalHits={totalHits}
          selectedTaxonomy={selectedTaxonomy?.key}
          selectedLocation={selectedLocation}
          selectedFacets={selectedFacetOptions}
          presentation="h4"
          serif
          className={styles.title}
        />
        <div className={styles.searchBarDesktop}>
          <InlineSearchBar
            selectedLocation={selectedLocation}
            allowInteractiveSearch
            updateSelectedLocation={updateSelectedLocation}
            selectedTaxonomyNode={nextTaxonomySearch}
            setSelectedTaxonomyNode={setNextTaxonomySearch}
            navigateToSrp={navigateToSrp}
            className={styles.searchBar}
            variant="white"
            reverse
            short
            shouldCloseDropdown={shouldCloseDropdowns}
            searchIcon
          />

          <div className={styles.saveSearch}>
            <SavedSearchesButton vendorSearch={vendorSearch} className={styles.saveSearchLink} />
            <SaveNewSearchButton
              vendorSearch={vendorSearch}
              selectedFacetOptions={selectedFacetOptions}
              availabilityDates={availabilityDates}
              component="link"
              className={styles.saveSearchLink}
            />
          </div>
        </div>
        <div className={styles.searchBarMobile}>
          <MobileSearchDropdownsPlaceholder />
          <SavedSearchesButton className={styles.saveSearchLink} />
        </div>
      </div>
    </PageSection>
  );
};
